import React from 'react';

// Components
import SignupForm from '../components/Form/SignupForm';

const SignUp = () => {
	return (
		<section className="signup">
			<SignupForm />
		</section>
	);
};

export default SignUp;
